'use strict';

import React from 'react';
import Row from '../tag/Row';
import Span from '../tag/Span';
import classnames from 'classnames';
import { formatDate, formatTime } from '../../utils/TimeUtils';

const ReservationListItem = ({ isShort, item, children }) => {
  return (
    <li
      className={classnames('appointment', { 'appointment--short': isShort })}
    >
      <Row>
        <Span len="3" sm-len="4">
          {formatDate(item.dateStart)}
        </Span>
        <Span len="4" sm-len="8">
          <span className={'show-mobile'}>klo </span>
          {formatTime(item.dateStart)} - {formatTime(item.dateEnd)}
        </Span>
        {children && (
          <Span len={'5'} sm-len={'12'}>
            {children}
          </Span>
        )}
      </Row>
    </li>
  );
};

export default ReservationListItem;
